import React, { useState } from "react";
import { IconButton, Tooltip, Menu, MenuItem, Divider } from "@mui/material";
import PersonIcon from '@mui/icons-material/Person';
import { useAuth0 } from "@auth0/auth0-react";
import { useUserInfoContext } from "../../contexts/UserInfoContext";
import {Link as RouterLink} from "react-router-dom";
// import pdf from "../../documents/C3AdvisorGuideGeneral.pdf";
// require("../../documents/C3AdvisorGuideGeneral.pdf")

export const UserButton = (props) => {
  const { loginWithRedirect, logout, isAuthenticated, isLoading } = useAuth0();
  const {checkIfUserHasRole} = useUserInfoContext();

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  

  return (
    <>
      <Tooltip title="Account Options">
        <IconButton onClick={handleClick}>
          <PersonIcon/>
        </IconButton>
      </Tooltip>
      <Menu 
        anchorEl={anchorEl}
        onClose={handleClose}
        open={open}
      >

        {checkIfUserHasRole('orgAdmin') && 
          <MenuItem component={RouterLink} to="/settings">Organization Management</MenuItem>
        }
        {checkIfUserHasRole('admin') && 
          <MenuItem component={RouterLink} to="/admin">Admin Home</MenuItem>
        }
        <MenuItem component={RouterLink} to={require("../../documents/C3AdvisorGuide.pdf")} target="_blank">
          Help
        </MenuItem>
        <Divider variant="middle"/>
        {isAuthenticated ? 
          <MenuItem onClick={() => logout({returnTo: window.location.origin})}>Logout</MenuItem> :
          <MenuItem onClick={loginWithRedirect}>Logout</MenuItem>
        }
      </Menu>
    </>
  )
}